import { render } from "./NotificationsPage.vue?vue&type=template&id=7a6cb0e0&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=7a6cb0e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6cb0e0"]])

export default __exports__